/* eslint-disable @typescript-eslint/camelcase */
import { StringMap } from '../common/interfaces/stringMap';
import { EXPERIENCE_DOMAIN_CONFIG, EXPERIENCE_HOST_DOMAINS } from './domainConfig';

type COOKIE_BOT_API_KEY = {
  [key in EXPERIENCE_DOMAIN_CONFIG]: {
    admin: string;
    player: string;
  };
};

interface Config {
  src: string;
  apiKey: COOKIE_BOT_API_KEY;
  localeMap: StringMap;
}

export const cookieBotConfig: Config = {
  src: 'https://consent.cookiebot.com/uc.js',
  apiKey: {
    [EXPERIENCE_HOST_DOMAINS.localhost]: {
      admin: '',
      player: 'd06e3d20-d2a6-4dd2-971d-f8e0ca4bfbff',
    },
    [EXPERIENCE_HOST_DOMAINS.mumbai]: {
      admin: '',
      player: '39af92fb-6c8b-46bc-99f6-f80bf11c8187',
    },
    [EXPERIENCE_HOST_DOMAINS.euDev]: {
      admin: '',
      player: 'd06e3d20-d2a6-4dd2-971d-f8e0ca4bfbff',
    },
    [EXPERIENCE_HOST_DOMAINS.qa1]: {
      admin: '036fc6f8-de34-4af9-9675-bd4e0ef8fdc7',
      player: '29561b44-fdc8-4596-99c5-22656d26e7ed',
    },
    [EXPERIENCE_HOST_DOMAINS.qa2]: {
      admin: '21febb96-70a4-4711-8620-117fa679f237',
      player: '7b0f77ef-83b6-44f0-8f53-168f91033af6',
    },
    [EXPERIENCE_HOST_DOMAINS.qa3]: {
      admin: '',
      player: 'a82364d8-7615-4db6-b9e4-d4167bb7d47c',
    },
    [EXPERIENCE_HOST_DOMAINS.qa4]: {
      admin: '',
      player: '63ff325e-8bf8-424c-8988-3508746873ca',
    },
    [EXPERIENCE_HOST_DOMAINS.uatAM]: {
      admin: '',
      player: '147d3aee-5678-4296-906d-196cbccd781e',
    },
    [EXPERIENCE_HOST_DOMAINS.uatEU]: {
      admin: 'b6affead-ba19-4644-95cf-820a50d1b6b1',
      player: '70056fc9-7b4a-4010-b080-6d41da03be56',
    },
    [EXPERIENCE_HOST_DOMAINS.uatUS]: {
      admin: '',
      player: '',
    },
    [EXPERIENCE_HOST_DOMAINS.stagingEU]: {
      admin: '694a81a4-ad2a-48b2-a8b4-0f2a017ee2ae',
      player: '76456ef7-1ca3-462c-a7c4-30d6b1f23b61',
    },
    [EXPERIENCE_HOST_DOMAINS.stagingUS]: {
      admin: '',
      player: '',
    },
    [EXPERIENCE_HOST_DOMAINS.au]: {
      admin: '8efdf9c6-6aa6-4c4d-9348-65ecf8909475',
      player: '0e5818af-1bf8-49c2-af7e-c26cde15b269',
    },
    [EXPERIENCE_HOST_DOMAINS.cn]: {
      admin: '',
      player: '',
    },
    [EXPERIENCE_HOST_DOMAINS.eu]: {
      admin: '08b95af1-25a6-4dee-806e-5cfbee95ff3c',
      player: 'd3118d06-7ab6-4e3b-b00e-d6418a377f72',
    },
    [EXPERIENCE_HOST_DOMAINS.us]: {
      admin: '073628fb-8ad4-4609-a90e-cf8650ca0196',
      player: 'a21e3f64-78fa-4fb0-aad9-c9b6817d66e3',
    },
    [EXPERIENCE_HOST_DOMAINS.au1]: {
      admin: '',
      player: '6f929c7a-9063-4fbe-b2c6-08190717ed4c',
    },
    [EXPERIENCE_HOST_DOMAINS.cn1]: {
      admin: '',
      player: '',
    },
    [EXPERIENCE_HOST_DOMAINS.eu1]: {
      admin: '',
      player: '707c84dc-9caa-4ebe-8dc3-5ce82b655f27',
    },
    [EXPERIENCE_HOST_DOMAINS.us1]: {
      admin: '',
      player: 'afd0459f-5931-4a71-bddf-d4f4a37d1bc2',
    },
  },
  localeMap: {
    cs_cz: 'cs',
    da_dk: 'da',
    de_de: 'de',
    et_et: 'et',
    en_gb: 'en',
    en_us: 'en',
    es_es: 'es',
    es_mx: 'es',
    el_gr: 'el',
    fr_fr: 'fr',
    fr_be: 'fr',
    is_is: 'is',
    it_it: 'it',
    lv_lv: 'lv',
    lt_lt: 'lt',
    hu_hu: 'hu',
    nl_nl: 'nl',
    no_no: 'nb',
    pl_pl: 'pl',
    pt_pt: 'pt',
    pt_br: 'pt',
    ru_ru: 'ru',
    ro_ro: 'ro',
    fi_fi: 'fi',
    nl_be: 'nl',
    ja_jp: 'ja',
    ko_kr: 'ko',
    sk_sk: 'sk',
    sr_sr: 'sr',
    sv_se: 'sv',
    tr_tr: 'tr',
    in_in: 'id',
    zh_cn: 'zh',
    zh_tw: 'en',
    th_th: 'th',
    fr_ca: 'fr',
    ar: 'ar',
  },
};
